/**
 * An IIFE service which provides a methods for calling API endpoints
 *
 * @function APIService
 * @returns {object} Various public interface methods
 */
 // TODO: Dynamic host name

    import config from "../configLoader";
const APIService = (function() {

    // *** Public interface ***//

    return {
        GetAvailableMaps: function () {
            return get('http://mc-demo.orchestr8.ai:8086/wayfinding/v1/assets/metadata/search?structure=AmericanDream')
                    .then(res => res.json());
        },
        GetMapSVG: function (mapMeta) {
            return get('http://mc-demo.orchestr8.ai:8086/wayfinding/v1/assets/search?structure=' + mapMeta.structure + '&level=' + mapMeta.level)
                    .then(res => res.text())
                    .then(str => (new window.DOMParser()).parseFromString(str, "image/svg+xml"));
        },
        GetMockMapSVG: function (mapMeta) {
            //return get('/mockmap' + mapMeta.level + '.svg')
            return get('/AmericanDream.Floor' + mapMeta.level + '.ScaledA.svg')
                    .then(res => res.text())
                    .then(str => (new window.DOMParser()).parseFromString(str, "image/svg+xml"));
        },
        GetAllUserLocations: function () {
            return get('http://mc-demo.orchestr8.ai:8086/wayfinding/v1/locations/events')
                    .then(res => res.json());
        },
        GetConfig () {
            return get('http://mc-demo.orchestr8.ai:8086/wayfinding/v1/config/beacons')
                .then(res => res.json());
        },
        GetAOIs: function () {
            // this gets them all, may want a more qualified way soon
            return get('http://mc-demo.orchestr8.ai:8086/wayfinding/v1/waypoints?startsWith=AmericanDream')
                .then(res => res.json());
        },
        GetPOIs: function () {
            // this gets them all, may want a more qualified way soon
            return get('http://mc-demo.orchestr8.ai:8001/rest/pois/')
                .then(res => {
                    if (res) {
                        return res.json();
                    }
                })
                .catch(err => console.warn(`@@ GetPOIs error: ${err}`));
        },
        // this for example gets one AOI (?Waypoint?)...
        // https://wayfinding-task-service.dev.ad.l11.com/wayfinding/v1/waypoints/Level11.Floor20.4681/
    }

    // *** Private methods ***//

    function get (url) {
        return fetch(url)
            .then(response => {
                return response;
            }, rejection => {
                handleRejection(url, rejection);
                return rejection;
            })
            .catch(error => {
                handleError(url, error);
                return error;
            });
    }

    function handleError (url, error) {
        // TODO: Bubble up to error display
        console.error("APIService: An error occurred when fetching " + url + ".", error);
    }

    function handleRejection (url, rejection) {
        // TODO: Bubble up to error display
        console.error("APIService: A rejection occurred when fetching " + url + ".", rejection);
    }

})();

export default APIService;



// WEBPACK FOOTER //
// ./src/services/API.js